// Archetype and role badge components for the HeroPanel.
// Color-coded chips showing hero archetype (Warlord/Tactician/etc.)
// and current role assignment (General/Spymaster/etc.).

import { SceneImage } from '@aod/ui/components/ui/scene';
import { isSceneId, sceneUrls } from '../scenes.js';

export function ArchetypeBadge({ archetype }: { readonly archetype: string }) {
  const colorMap: Record<string, string> = {
    Warlord: 'bg-red-500/15 text-red-700 dark:text-red-300',
    Tactician: 'bg-blue-500/15 text-blue-700 dark:text-blue-300',
    Spymaster: 'bg-purple-500/15 text-purple-700 dark:text-purple-300',
    Sage: 'bg-cyan-500/15 text-cyan-700 dark:text-cyan-300',
    Diplomat: 'bg-amber-500/15 text-amber-700 dark:text-amber-300',
    Champion: 'bg-emerald-500/15 text-emerald-700 dark:text-emerald-300',
  };
  return (
    <span
      className={`rounded px-1.5 py-0.5 text-[10px] font-medium ${colorMap[archetype] ?? 'bg-muted/20'}`}
    >
      {archetype}
    </span>
  );
}

export function RoleBadge({ role }: { readonly role: string }) {
  const id = role.toLowerCase();
  return (
    <span className="inline-flex items-center gap-1 rounded bg-muted/40 px-1.5 py-0.5 text-[10px] font-medium text-foreground/70">
      {isSceneId('heroRole', id) && (
        <SceneImage
          {...sceneUrls('heroRole', id)}
          widths={[64, 256]}
          sizes="16px"
          aspect="square"
          rounded="none"
          scrim={false}
          className="size-4 shrink-0"
        />
      )}
      {role}
    </span>
  );
}
